export const HOME = "/";
export const ABOUT_US = "/about-us";
export const OUR_PARTNERS = "/our-partners";
export const VALUE_ADDED_SERVICES = "/value-added-services";
export const CONTACT_US = "/contact";
export const BECOME_AGENT = "/become-agent";
export const LOGIN = "/login";
export const FORGOT_PASSWORD = "/forgot-password";
export const RESET_PASSWORD = "/reset-password";
export const MEDIA_NEWS_DETAILS = "/media/news/:id";
export const MEDIA_EVENT_DETAILS = "/media/gallery/:id";
export const MEDIA = "/media/";

// Banks Routes
export const BANKS = "/banks/";
export const ADD_BANK = "/banks/add";
export const EDIT_BANK = "/banks/edit/:id";

// Super Agent Routes
export const SUPER_AGENT = "/super-agents";
export const ADD_SUPER_AGENT = "/super-agent/add";
export const EDIT_SUPER_AGENT = "/super-agent/edit/:id";

// Regulator Routes
export const REGULATORS = "/regulators";
export const ADD_REGULATOR = "/regulators/add";
export const EDIT_REGULATOR = "/regulators/edit/:id";

// Strategic Partner
export const STRATEGIC_PARTNERS = "/strategic-partners";
export const ADD_STRATEGIC_PARTNERS = "/strategic-partners/add";
export const EDIT_STRATEGIC_PARTNERS = "/strategic-partners/edit/:id";

// Governments/MDA's
export const GOVERNMENTS = "/governments";
export const ADD_GOVERNMENT = "/governments/add";
export const EDIT_GOVERNMENT = "/governments/edit/:id";

// Agents
export const AGENTS = "/agents";
export const ADD_AGENT = "/agents/add";
export const EDIT_AGENT = "/agents/edit/:id";

// Admin Settings
export const ADMIN_SETTINGS = "/admin-settings";
